import * as React from "react";
import {useEffect, useState} from "react";
import {collection, onSnapshot, query} from "firebase/firestore";
import {db} from "./Admin";
import css from "../css/admin.module.css";
import DialogMUI from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {post} from "./post";


export const Users = () => {
    const [users, setUsers] = useState(null);
    const [settings, setSettings] = useState(null);
    const [stat, setStat] = useState(null);
    const [solvings, setSolvings] = useState(null);
    const [uSolvings, setUSolvings] = useState(null);

    useEffect(() => {
        const unsubscribes = [];
        unsubscribes.push(onSnapshot(collection(db, "settings"), s => setSettings(s.docs.reduce((a, c) => ({
            ...a,
            [c.id]: c.data()
        }), {}))));
        unsubscribes.push(onSnapshot(collection(db, "users"), s => setUsers(s.docs.map(doc => ({id: doc.id, ...doc.data()})))));
        unsubscribes.push(onSnapshot(query(collection(db, "stat")), s => setStat(s.docs.map(doc => doc.data()))));
        unsubscribes.push(onSnapshot(collection(db, "solvings"), s => {
            setSolvings(s.docs.reduce((a, c) => ({
                ...a,
                [c.id]: (a => {
                    const start = a.reduce((acc, c) => acc ? Math.min(acc, c.date) : c.date, 0);
                    const last = a.reduce((acc, c) => Math.max(acc, c.date), 0);
                    const days = (last - start) / 1000 / 60 / 60 / 24 + 1;

                    const startDate = new Date(start).toLocaleDateString("ru");
                    const lastDate = new Date(last).toLocaleDateString("ru");

                    const right = a.filter(a => a.isRight).length;
                    const notRight = a.filter(a => !a.isRight).length;
                    return ({days, startDate, lastDate, right, notRight})
                })(Object.values(c.data()))
            }), {}))
        }));

        return () => unsubscribes.forEach(unsubscribe => unsubscribe())
    }, []);

    if(!stat || !solvings || !settings || !users) return ;


    users.sort((a, b) => a.startTrial - b.startTrial);

    const courses = settings?.props?.courses ? settings.props.courses.reduce((a, c) => ({
        ...a,
        [c.id]: c.text
    }), {}) : {};



    users.forEach(user => {
        user.stat = stat.filter(s => s.userId === user.id);
        user.authData = user.stat[0]?.authData || {};
        user.solvings = solvings[user.id] || {days: 0, right: 0, notRight: 0};
        user.link = user.id.startsWith("vk-") && `https://vk.com/id${user.id.slice(3)}`
    });

    console.log(stat.length);
    console.log(stat.filter(s => s.userId === "vk-554220229").length);

    const deleteUser = async (userId) => {
        if (!window.confirm(`Delete User Data ${userId}?`)) return;
        await post("deleteUserData", {userId});
    }

    return (
        <div className={css.users}>
            <table>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Delete</th>
                    <th>Photo</th>
                    <th>UserId</th>
                    <th>StartDate</th>
                    <th>LastDate</th>
                    <th>Days</th>
                    <th>Right</th>
                    <th>NotRight</th>
                    <th>Courses</th>
                </tr>
                </thead>
                <tbody>
                {users.map((user, i) => (
                    <tr key={user.id} id={user.id}>
                        <td>{i + 1}</td>
                        <td>
                            <button onClick={() => deleteUser(user.id)}>Delete</button>
                        </td>
                        <td><img width={108} height={108} alt={""} src={user.authData.photo}/></td>
                        <td>
                            <div>{user.link ? <a target={"_blank"} rel={"nofollow noreferrer noopener"}
                                                 href={user.link}>{user.id}</a> : user.id}</div>
                            <div>
                                <nobr>{user.authData.username}</nobr>
                            </div>
                            <div>{user.authData.lang} {[...new Set(user.stat[0]?.ip.map(i => i.id.country))].join(" | ")}</div>
                            <div>{user.authData.version}</div>
                            <div>{new Date(user.startTrial).toLocaleDateString("ru")}</div>

                        </td>
                        <td>{user.solvings.startDate}</td>
                        <td>{user.solvings.lastDate}</td>
                        <td>{user.solvings.days}</td>
                        <td>{user.solvings.right}</td>
                        <td>{user.solvings.notRight}</td>
                        <td>{user.courses.map(c => (<div key={c}>{courses[c]}</div>))}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}
